/**
 * mockEquipmentPhotoAdapter — client-side photo-adapter a státusz-átmenet DAMAGED-fotóihoz (mock-first).
 *
 * A seam (`equipmentUnitStatusTransitionSchema`) csak `photoIds[]`-t vár; a fotó-feltöltő **endpoint**
 * BE-oldalon még NINCS definiálva → ez az adapter kliens-oldalon ad vissza `{url, id}`-t (objectURL +
 * uuid), hogy a flow mock-first működjön. **Swap** a valós `IPhotoStorageAdapter`-re (server-proxied
 * multipart, a HandoverPhotoUploader BE-1 mintára), amikor a BE photo-upload endpoint élesedik.
 */
import type { IPhotoStorageAdapter } from '@kgc/ui';

export const mockEquipmentPhotoAdapter: IPhotoStorageAdapter = {
  async upload(file: File) {
    return { url: URL.createObjectURL(file), id: crypto.randomUUID() };
  },
};
